import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { campaigns: () => import('./CampaignsPage.vue') },
} satisfies FeatureRoutes
